import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';
import { formatPrice } from '../../../../utils/formatPrice';
import { SiteLocale } from 'apps/website/types/dato';
import { numberEmployeeStyle } from '../scripts/commonStyles';
import { fontCaption, fontCaptionMedium } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';

type FooterProps = {
  oBFeesTitle: string;
  oBFeesLabel: string;
  oBFeesPrice: number;
  numberEmployee: number;
  locale: SiteLocale;
};

const Footer = ({
  oBFeesTitle,
  oBFeesLabel,
  oBFeesPrice,
  numberEmployee,
  locale,
}: FooterProps) => {
  return (
    <div
      className={classNames(
        'PriceBreakdown_Footer',
        'flex flex-col gap-x-16 gap-y-[2px]',
      )}
    >
      <div className={classNames(fontCaptionMedium)}>{oBFeesTitle}</div>
      <div
        className={classNames(
          'flex justify-between gap-x-16 gap-y-[2px] text-[#55687D]',
          fontCaption,
        )}
      >
        <div className={classNames(fontCaption)}>{oBFeesLabel}</div>
        <div className={classNames(fontCaption)}>
          {formatPrice(oBFeesPrice, locale)} x{' '}
          <span className={classNames(numberEmployeeStyle)}>
            {numberEmployee}
          </span>{' '}
          = {formatPrice(oBFeesPrice * numberEmployee, locale)}
        </div>
      </div>
    </div>
  );
};

export default Footer;
